import React, { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import '../css/backToTop.css';

export default function BackToTop() {
    const [visible, setVisible] = useState(false);

    const handleScroll = () => {
        if (window.scrollY > 300) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <button
            type="button"
            aria-label="Back to top"
            className={`modern-back-to-top ${visible ? 'visible' : ''}`}
            onClick={handleClick}
        >
            <FaArrowUp />
        </button>
    );
}
